import { isBefore } from 'date-fns';
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

import { intervalToDuration, type Duration } from '@/utils/interval-to-duration.ts';

export type { Duration };

const zeros: Duration = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

export const useTimer = (targetDate: Date | string, initialNow?: () => Date): Duration => {
  const [now, setNow] = useState(initialNow ?? (() => new Date()));
  const active = isBefore(now, targetDate);

  useInterval(() => setNow(new Date()), active ? 1000 : null);

  if (!active) {
    return zeros;
  }

  return intervalToDuration({
    start: now,
    end: targetDate,
  });
};
